import {i18n} from "@/plugins/i18n";

export const chargeByReceiptActionType = {
    FINALIZE: 1,
    CANCEL: 2,
}

export const chargeByReceiptActionTypeStr = {
    FINALIZE: i18n.t('label.finalize_receipt'),
    CANCEL: i18n.t('btn.make_failed'),

    get(type) {
        let gender_str = null;

        Object.keys(chargeByReceiptActionType).forEach((item, index) => {
            if(chargeByReceiptActionType[item] === type) {
                gender_str = chargeByReceiptActionTypeStr[item];
            }
        });

        return gender_str;
    }
}